import { atom } from "jotai";

import { zapNodesAtom } from "../nodes";

export const zapIdsAtom = atom((get) => {
  const nodes = get(zapNodesAtom);
  return nodes.map((node) => node.data.zapId).filter(Boolean) as string[];
});

zapIdsAtom.debugLabel = "zapIdsAtom";
